var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGuides = function SvgGuides(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 5.273V45H6.592a6.592 6.592 0 01-6.46-5.273A7.219 7.219 0 010 38.408c0-1.82.211-3.48 1.398-4.667L7.91 5.273H45z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5.273H25.137V45H45V5.273z",
    fill: "#444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.727 10.547H13.184v29.18h26.543v-29.18z",
    fill: "#A07C97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.727 10.547h-14.59v29.18h14.59v-29.18z",
    fill: "#612551"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.365 23.818h-7.91V15.82h7.91v7.998zM34.365 34.453h-7.91v-7.998h7.91v7.998z",
    fill: "#DFD7D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.818 23.818H15.82V15.82h7.998v7.998zM23.818 34.453H15.82v-7.998h7.998v7.998z",
    fill: "#EDE9E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.184 6.592v31.816c0-1.82-.739-3.48-1.925-4.667a6.597 6.597 0 00-4.667-1.925c-1.82 0-3.48.739-4.667 1.925A6.598 6.598 0 000 38.408V6.592A6.594 6.594 0 016.592 0c1.82 0 3.48.738 4.667 1.925a6.598 6.598 0 011.925 4.667z",
    fill: "#929298"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuides, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guides.b28a05dd.svg";
export { ForwardRef as ReactComponent };